// extracted by mini-css-extract-plugin
export default {"page":"V2Chrome_page__0dZMD","main":"V2Chrome_main__5xSU6"};